import {animate, state, style, transition, trigger} from '@angular/animations';
import {Component} from '@angular/core';

import {Toast, ToastPackage, ToastrService} from 'ngx-toastr';

interface ToastTypeConfig {
  key: 'info' | 'success' | 'warning' | 'danger';
  icon: string;
}

/**
 * Custom toast used by ngx-toastr. Renders a white card with a colored left
 * border, a type icon, an optional title (shown only when the caller provides
 * one) and the message.
 *
 * Type mapping (ngx-toastr type -> our type):
 *  - toast-info    -> info    (blue)
 *  - toast-success -> success (green)
 *  - toast-warning -> warning (orange)
 *  - toast-error   -> danger  (red)
 */
@Component({
  selector: '[gp-toast-message]',
  templateUrl: './toast-message.component.html',
  styleUrls: ['./toast-message.component.scss'],
  animations: [
    trigger('flyInOut', [
      state('inactive', style({opacity: 0})),
      state('active', style({opacity: 1})),
      state('removed', style({opacity: 0})),
      transition('inactive => active', animate('{{ easeTime }}ms {{ easing }}')),
      transition('active => removed', animate('{{ easeTime }}ms {{ easing }}'))
    ])
  ]
})
export class ToastMessageComponent extends Toast {

  private static readonly TYPES: { [type: string]: ToastTypeConfig } = {
    'toast-info': {key: 'info', icon: 'fa-solid fa-circle-info'},
    'toast-success': {key: 'success', icon: 'fa-solid fa-circle-check'},
    'toast-warning': {key: 'warning', icon: 'fa-solid fa-triangle-exclamation'},
    'toast-error': {key: 'danger', icon: 'fa-solid fa-diamond-exclamation'}
  };

  constructor(protected toastrService: ToastrService, public toastPackage: ToastPackage) {
    super(toastrService, toastPackage);
  }

  public get config(): ToastTypeConfig {
    return ToastMessageComponent.TYPES[this.toastPackage.toastType] || ToastMessageComponent.TYPES['toast-info'];
  }


  public close(event: MouseEvent): void {
    event.stopPropagation();
    this.remove();
  }
}

